import { render, staticRenderFns } from "./session_pills_bar.vue?vue&type=template&id=1a1adc53"
import script from "./session_pills_bar.vue?vue&type=script&lang=js"
export * from "./session_pills_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports